import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { beneficiosTranslations } from '../../translations';
import styles from './RechargePaymentHeader.module.css';
function RechargePaymentHeaderContent({ rechargeValue = 0, translationKey = 'benefits.recharge.payment.bolepix.header.payMessage', }) {
    const { t } = useTranslation();
    const formattedValue = rechargeValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
    return (_jsxs("div", { className: styles.header, "data-testid": 'viewRechargePaymentHeaderContainer', children: [_jsx(Icon, { name: 'benefitAllProductsCheck', "data-testid": 'iconRechargePaymentHeaderCheck' }), _jsx("h2", { className: styles.title, "data-testid": 'textViewRechargePaymentHeaderTitle', children: t(translationKey, { value: formattedValue }) })] }));
}
export const RechargePaymentHeader = props => {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, children: _jsx(RechargePaymentHeaderContent, { ...props }) }));
};
